import type { QuadrantItemData } from './QuadrantItem';

/** True when the hash path is the dashboard (ignores query string). */
export function isDashboardHash(hash: string = typeof window !== 'undefined' ? window.location.hash : ''): boolean {
    const path = hash.replace(/^#/, '').split('?')[0].trim().toLowerCase();
    return path === '' || path === 'dashboard';
}

/** Strip entitlement marker and normalize for label matching. */
export function normalizeDashboardItemLabel(label: string): string {
    return label.replace(/\u00A0\*/g, '').trim().toLowerCase();
}

export function dashboardItemMatchesFilter(item: QuadrantItemData, rawQuery: string): boolean {
    const query = rawQuery.trim().toLowerCase();
    if (!query || query.includes(',')) return true;
    const candidates = [item.label, item.sortLabel].filter(Boolean) as string[];
    return candidates.some((label) => normalizeDashboardItemLabel(label).includes(query));
}

/** True when the dashboard filter should dim tiles and collapse empty quadrants (not comma All Users search). */
export function isDashboardTileFilterActive(rawQuery: string): boolean {
    const query = rawQuery.trim();
    return query.length > 0 && !query.includes(',');
}

/** Whether a quadrant has at least one tile matching the active dashboard filter. */
export function quadrantHasFilterMatch(items: QuadrantItemData[], rawQuery: string): boolean {
    if (!isDashboardTileFilterActive(rawQuery)) return true;
    return items.some((item) => dashboardItemMatchesFilter(item, rawQuery));
}

/** Hash route for All Users list with simple search (readable commas in search param). */
export function buildPersonSearchHash(search: string): string {
    const trimmed = search.trim();
    if (!trimmed) return 'Person';
    const params = new URLSearchParams();
    params.set('search', trimmed);
    let qs = params.toString();
    qs = qs.replace(/search=([^&]*)/gi, (_m, value) => `search=${String(value).replace(/%2C/gi, ',')}`);
    return `Person?${qs}`;
}
